// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.handsonbtn {
    margin-top: 7px;
    background-color: #047E35;
    font-size: 18px; 
    border-radius: 3px; 
    width: 40%; 
    border: 1px solid #156614;
    height: 52px;
    color: #ffffff
}

.handarrow1 {
    position: absolute; 
    left: 14%;
}

.handarrow2 {
    position: absolute; 
    right: 14%;
}

.handarrow3 {
    position: absolute; 
    bottom: -49%; 
    left: 36%;
}

.handsprint {
    position: absolute; 
    bottom: 45%; 
    left: 47%;
}

.handprojectr {
    position: absolute;
    bottom: 10%; 
    left: 5%;
}

.handprojects {
    position: absolute; 
    bottom: 10%; 
    right: 10%;
}

.accelerateTech {
    position: relative;
    background-color: #156614; 
    height: 320px; 
    width: 100%; 
    margin-bottom: 20px;
}

.handssadmission {
    position: relative;
    background-color: #156614; 
    height: 500px; 
    width: 100%; 
    margin-bottom: 20px;
}

.handpeertopeer {
    position: relative; 
    background-color: #156614; 
    height: 500px; 
    width: 100%; 
    margin-bottom: 20px;
}

.handsproreview {
    position: relative; 
    background-color: #156614; 
    height: 430px; 
    width: 100%; 
    margin-bottom: 20px;
}

.projectreeeview {
    position: relative; 
    background-color: #156614; 
    height: 450px; 
    width: 100%; 
    margin-bottom: 20px;
}

.careerpathss2 {
    border: 1px solid #696969;
    border-radius: 10px;
}

.careerpathss2error {
    border: 1px solid #696969;
    border-radius: 10px;
}

.addmiss {
    margin-top: 150px; 
    text-align: left;
    cursor: pointer;
}

.addmiss:hover {
    color: #156614;
}

.otherhowwork {
    text-align: left; 
    cursor: pointer;
}

.otherhowwork:hover {
    text-align: left; 
    color: #156614;
}

.handsondia {
    margin-top: 80px;
}

@media (min-width: 297px) and (max-width: 363px){
    .handsondia {
        margin-top: 30px;
        width: 100%
    }

    .handsonbtn {
        margin-top: 7px;
        background-color: #047E35;
        font-size: 18px; 
        border-radius: 3px; 
        width: 100%; 
        border: 1px solid #156614;
        height: 52px;
        color: #ffffff
    }
    
    .handarrow1 {
        position: absolute; 
        left: -23%;
    }
    
    .handarrow2 {
        position: absolute; 
        right: -23%;
    }
    
    .handarrow3 {
        position: absolute; 
        bottom: -45%; 
        left: 18%;
    }
    
    
    .handsprint {
        position: absolute; 
        bottom: 45%; 
        left: 43%;
    }
    
    .handprojectr {
        position: absolute;
        bottom: 10%; 
        left: 5%;
    }
    
    .handprojects {
        position: absolute; 
        bottom: 10%; 
        right: 10%;
    }

    .accelerateTech {
        position: relative;
        background-color: #156614; 
        height: 250px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handssadmission {
        margin-top: 20px;
        position: relative;
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handpeertopeer {
        position: relative; 
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handsproreview {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .projectreeeview {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
}



@media (min-width: 365px) and (max-width: 393px){
    .handsondia {
        margin-top: 30px;
        width: 100%
    }

    .handsonbtn {
        margin-top: 7px;
        background-color: #047E35;
        font-size: 18px; 
        border-radius: 3px; 
        width: 100%; 
        border: 1px solid #156614;
        height: 52px;
        color: #ffffff
    }
    
    .handarrow1 {
        position: absolute; 
        left: -23%;
    }
    
    .handarrow2 {
        position: absolute; 
        right: -23%;
    }
    
    .handarrow3 {
        position: absolute; 
        bottom: -45%; 
        left: 18%;
    }
    
    
    .handsprint {
        position: absolute; 
        bottom: 45%; 
        left: 43%;
    }
    
    .handprojectr {
        position: absolute;
        bottom: 10%; 
        left: 5%;
    }
    
    .handprojects {
        position: absolute; 
        bottom: 10%; 
        right: 10%;
    }

    .accelerateTech {
        position: relative;
        background-color: #156614; 
        height: 250px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handssadmission {
        margin-top: 20px;
        position: relative;
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handpeertopeer {
        position: relative; 
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handsproreview {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .projectreeeview {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
}




@media (min-width: 394px) and (max-width: 530px){
    .handsondia {
        margin-top: 30px;
        width: 100%
    }

    .handsonbtn {
        margin-top: 7px;
        background-color: #047E35;
        font-size: 18px; 
        border-radius: 3px; 
        width: 100%; 
        border: 1px solid #156614;
        height: 52px;
        color: #ffffff
    }
    
    .handarrow1 {
        position: absolute; 
        left: -15%;
    }
    
    .handarrow2 {
        position: absolute; 
        right: -15%;
    }
    
    .handarrow3 {
        position: absolute; 
        bottom: -45%; 
        left: 18%;
    }
    
    .handsprint {
        position: absolute; 
        bottom: 45%; 
        left: 43%;
    }
    
    .handprojectr {
        position: absolute;
        bottom: 10%; 
        left: 5%;
    }
    
    .handprojects {
        position: absolute; 
        bottom: 10%; 
        right: 10%;
    }
    
    .accelerateTech {
        position: relative;
        background-color: #156614; 
        height: 250px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handssadmission {
        margin-top: 20px;
        position: relative;
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handpeertopeer {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 370px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handsproreview {
        margin-top: 70px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .projectreeeview {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }

}

@media (min-width: 532px) and (max-width: 567px){
    .handsondia {
        margin-top: 30px;
        width: 100%
    }
    
    .handsonbtn {
        margin-top: 7px;
        background-color: #047E35;
        font-size: 18px; 
        border-radius: 3px; 
        width: 100%; 
        border: 1px solid #156614;
        height: 52px;
        color: #ffffff
    }
    
    .handarrow1 {
        position: absolute; 
        left: -5%;
    }
    
    .handarrow2 {
        position: absolute; 
        right: -5%;
    }
    
    .handarrow3 {
        position: absolute; 
        bottom: -55%; 
        left: 25%;
    }

    .handsprint {
        position: absolute; 
        bottom: 45%; 
        left: 43%;
    }
    
    .handprojectr {
        position: absolute;
        bottom: 10%; 
        left: 5%;
    }
    
    .handprojects {
        position: absolute; 
        bottom: 10%; 
        right: 10%;
    }

    .accelerateTech {
        margin-top: 50px;
        position: relative;
        background-color: #156614; 
        height: 250px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handssadmission {
        margin-top: 100px;
        position: relative;
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handpeertopeer {
        margin-top: 100px;
        position: relative; 
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handsproreview {
        margin-top: 100px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .projectreeeview {
        margin-top: 100px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }

    
    
}

@media  (min-width: 597px) and (max-width: 870px) {
    .handsonbtn {
        margin-top: 7px;
        background-color: #047E35;
        font-size: 18px; 
        border-radius: 3px; 
        width: 100%; 
        border: 1px solid #156614;
        height: 52px;
        color: #ffffff
    }
    
    .handarrow1 {
        position: absolute; 
        left: 0%;
    }
    
    .handarrow2 {
        position: absolute; 
        right: 0%;
    }
    
    .handarrow3 {
        position: absolute; 
        bottom: -43%; 
        left: 28%;
    }
    
    .handsprint {
        position: absolute; 
        bottom: 45%; 
        left: 43%;
    }
    
    .handprojectr {
        position: absolute;
        bottom: 10%; 
        left: 5%;
    }
    
    .handprojects {
        position: absolute; 
        bottom: 10%; 
        right: 10%;
    }

    .accelerateTech {
        position: relative;
        background-color: #156614; 
        height: 250px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handssadmission {
        margin-top: 20px;
        position: relative;
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handpeertopeer {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 390px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handsproreview {
        margin-top: 70px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .projectreeeview {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 360px; 
        width: 100%; 
        margin-bottom: 15px;
    }

    

}


@media (min-width: 600px) and (max-width: 970px){ 
    .accelerateTech {
        position: relative;
        background-color: #156614; 
        height: 200px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handarrow1 {
        position: absolute; 
        left: 0%;
    }
    
    .handarrow2 {
        position: absolute; 
        right: 0%;
    }
    
    .handarrow3 {
        position: absolute; 
        bottom: -43%; 
        left: 28%;
    }
    

    .handssadmission {
        margin-top: 20px;
        position: relative;
        background-color: #156614; 
        height: 300px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handpeertopeer {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 300px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .handsproreview {
        margin-top: 70px;
        position: relative; 
        background-color: #156614; 
        height: 270px; 
        width: 100%; 
        margin-bottom: 15px;
    }
    
    .projectreeeview {
        margin-top: 20px;
        position: relative; 
        background-color: #156614; 
        height: 270px; 
        width: 100%; 
        margin-bottom: 15px;
    }

}


`, "",{"version":3,"sources":["webpack://./src/components/Handsonexperience.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;IACb;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;AAEJ;;;;AAIA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;IACb;;;IAGA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;AAEJ;;;;;AAKA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;AAEJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;;;AAIJ;;AAEA;IACI;QACI,eAAe;QACf,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;;;AAIJ;;;AAGA;IACI;QACI,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,SAAS;IACb;;;IAGA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,WAAW;QACX,mBAAmB;IACvB;;AAEJ","sourcesContent":[".handsonbtn {\n    margin-top: 7px;\n    background-color: #047E35;\n    font-size: 18px; \n    border-radius: 3px; \n    width: 40%; \n    border: 1px solid #156614;\n    height: 52px;\n    color: #ffffff\n}\n\n.handarrow1 {\n    position: absolute; \n    left: 14%;\n}\n\n.handarrow2 {\n    position: absolute; \n    right: 14%;\n}\n\n.handarrow3 {\n    position: absolute; \n    bottom: -49%; \n    left: 36%;\n}\n\n.handsprint {\n    position: absolute; \n    bottom: 45%; \n    left: 47%;\n}\n\n.handprojectr {\n    position: absolute;\n    bottom: 10%; \n    left: 5%;\n}\n\n.handprojects {\n    position: absolute; \n    bottom: 10%; \n    right: 10%;\n}\n\n.accelerateTech {\n    position: relative;\n    background-color: #156614; \n    height: 320px; \n    width: 100%; \n    margin-bottom: 20px;\n}\n\n.handssadmission {\n    position: relative;\n    background-color: #156614; \n    height: 500px; \n    width: 100%; \n    margin-bottom: 20px;\n}\n\n.handpeertopeer {\n    position: relative; \n    background-color: #156614; \n    height: 500px; \n    width: 100%; \n    margin-bottom: 20px;\n}\n\n.handsproreview {\n    position: relative; \n    background-color: #156614; \n    height: 430px; \n    width: 100%; \n    margin-bottom: 20px;\n}\n\n.projectreeeview {\n    position: relative; \n    background-color: #156614; \n    height: 450px; \n    width: 100%; \n    margin-bottom: 20px;\n}\n\n.careerpathss2 {\n    border: 1px solid #696969;\n    border-radius: 10px;\n}\n\n.careerpathss2error {\n    border: 1px solid #696969;\n    border-radius: 10px;\n}\n\n.addmiss {\n    margin-top: 150px; \n    text-align: left;\n    cursor: pointer;\n}\n\n.addmiss:hover {\n    color: #156614;\n}\n\n.otherhowwork {\n    text-align: left; \n    cursor: pointer;\n}\n\n.otherhowwork:hover {\n    text-align: left; \n    color: #156614;\n}\n\n.handsondia {\n    margin-top: 80px;\n}\n\n@media (min-width: 297px) and (max-width: 363px){\n    .handsondia {\n        margin-top: 30px;\n        width: 100%\n    }\n\n    .handsonbtn {\n        margin-top: 7px;\n        background-color: #047E35;\n        font-size: 18px; \n        border-radius: 3px; \n        width: 100%; \n        border: 1px solid #156614;\n        height: 52px;\n        color: #ffffff\n    }\n    \n    .handarrow1 {\n        position: absolute; \n        left: -23%;\n    }\n    \n    .handarrow2 {\n        position: absolute; \n        right: -23%;\n    }\n    \n    .handarrow3 {\n        position: absolute; \n        bottom: -45%; \n        left: 18%;\n    }\n    \n    \n    .handsprint {\n        position: absolute; \n        bottom: 45%; \n        left: 43%;\n    }\n    \n    .handprojectr {\n        position: absolute;\n        bottom: 10%; \n        left: 5%;\n    }\n    \n    .handprojects {\n        position: absolute; \n        bottom: 10%; \n        right: 10%;\n    }\n\n    .accelerateTech {\n        position: relative;\n        background-color: #156614; \n        height: 250px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handssadmission {\n        margin-top: 20px;\n        position: relative;\n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handpeertopeer {\n        position: relative; \n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handsproreview {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .projectreeeview {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n}\n\n\n\n@media (min-width: 365px) and (max-width: 393px){\n    .handsondia {\n        margin-top: 30px;\n        width: 100%\n    }\n\n    .handsonbtn {\n        margin-top: 7px;\n        background-color: #047E35;\n        font-size: 18px; \n        border-radius: 3px; \n        width: 100%; \n        border: 1px solid #156614;\n        height: 52px;\n        color: #ffffff\n    }\n    \n    .handarrow1 {\n        position: absolute; \n        left: -23%;\n    }\n    \n    .handarrow2 {\n        position: absolute; \n        right: -23%;\n    }\n    \n    .handarrow3 {\n        position: absolute; \n        bottom: -45%; \n        left: 18%;\n    }\n    \n    \n    .handsprint {\n        position: absolute; \n        bottom: 45%; \n        left: 43%;\n    }\n    \n    .handprojectr {\n        position: absolute;\n        bottom: 10%; \n        left: 5%;\n    }\n    \n    .handprojects {\n        position: absolute; \n        bottom: 10%; \n        right: 10%;\n    }\n\n    .accelerateTech {\n        position: relative;\n        background-color: #156614; \n        height: 250px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handssadmission {\n        margin-top: 20px;\n        position: relative;\n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handpeertopeer {\n        position: relative; \n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handsproreview {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .projectreeeview {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n}\n\n\n\n\n@media (min-width: 394px) and (max-width: 530px){\n    .handsondia {\n        margin-top: 30px;\n        width: 100%\n    }\n\n    .handsonbtn {\n        margin-top: 7px;\n        background-color: #047E35;\n        font-size: 18px; \n        border-radius: 3px; \n        width: 100%; \n        border: 1px solid #156614;\n        height: 52px;\n        color: #ffffff\n    }\n    \n    .handarrow1 {\n        position: absolute; \n        left: -15%;\n    }\n    \n    .handarrow2 {\n        position: absolute; \n        right: -15%;\n    }\n    \n    .handarrow3 {\n        position: absolute; \n        bottom: -45%; \n        left: 18%;\n    }\n    \n    .handsprint {\n        position: absolute; \n        bottom: 45%; \n        left: 43%;\n    }\n    \n    .handprojectr {\n        position: absolute;\n        bottom: 10%; \n        left: 5%;\n    }\n    \n    .handprojects {\n        position: absolute; \n        bottom: 10%; \n        right: 10%;\n    }\n    \n    .accelerateTech {\n        position: relative;\n        background-color: #156614; \n        height: 250px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handssadmission {\n        margin-top: 20px;\n        position: relative;\n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handpeertopeer {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 370px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handsproreview {\n        margin-top: 70px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .projectreeeview {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n\n}\n\n@media (min-width: 532px) and (max-width: 567px){\n    .handsondia {\n        margin-top: 30px;\n        width: 100%\n    }\n    \n    .handsonbtn {\n        margin-top: 7px;\n        background-color: #047E35;\n        font-size: 18px; \n        border-radius: 3px; \n        width: 100%; \n        border: 1px solid #156614;\n        height: 52px;\n        color: #ffffff\n    }\n    \n    .handarrow1 {\n        position: absolute; \n        left: -5%;\n    }\n    \n    .handarrow2 {\n        position: absolute; \n        right: -5%;\n    }\n    \n    .handarrow3 {\n        position: absolute; \n        bottom: -55%; \n        left: 25%;\n    }\n\n    .handsprint {\n        position: absolute; \n        bottom: 45%; \n        left: 43%;\n    }\n    \n    .handprojectr {\n        position: absolute;\n        bottom: 10%; \n        left: 5%;\n    }\n    \n    .handprojects {\n        position: absolute; \n        bottom: 10%; \n        right: 10%;\n    }\n\n    .accelerateTech {\n        margin-top: 50px;\n        position: relative;\n        background-color: #156614; \n        height: 250px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handssadmission {\n        margin-top: 100px;\n        position: relative;\n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handpeertopeer {\n        margin-top: 100px;\n        position: relative; \n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handsproreview {\n        margin-top: 100px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .projectreeeview {\n        margin-top: 100px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n\n    \n    \n}\n\n@media  (min-width: 597px) and (max-width: 870px) {\n    .handsonbtn {\n        margin-top: 7px;\n        background-color: #047E35;\n        font-size: 18px; \n        border-radius: 3px; \n        width: 100%; \n        border: 1px solid #156614;\n        height: 52px;\n        color: #ffffff\n    }\n    \n    .handarrow1 {\n        position: absolute; \n        left: 0%;\n    }\n    \n    .handarrow2 {\n        position: absolute; \n        right: 0%;\n    }\n    \n    .handarrow3 {\n        position: absolute; \n        bottom: -43%; \n        left: 28%;\n    }\n    \n    .handsprint {\n        position: absolute; \n        bottom: 45%; \n        left: 43%;\n    }\n    \n    .handprojectr {\n        position: absolute;\n        bottom: 10%; \n        left: 5%;\n    }\n    \n    .handprojects {\n        position: absolute; \n        bottom: 10%; \n        right: 10%;\n    }\n\n    .accelerateTech {\n        position: relative;\n        background-color: #156614; \n        height: 250px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handssadmission {\n        margin-top: 20px;\n        position: relative;\n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handpeertopeer {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 390px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handsproreview {\n        margin-top: 70px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .projectreeeview {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 360px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n\n    \n\n}\n\n\n@media (min-width: 600px) and (max-width: 970px){ \n    .accelerateTech {\n        position: relative;\n        background-color: #156614; \n        height: 200px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handarrow1 {\n        position: absolute; \n        left: 0%;\n    }\n    \n    .handarrow2 {\n        position: absolute; \n        right: 0%;\n    }\n    \n    .handarrow3 {\n        position: absolute; \n        bottom: -43%; \n        left: 28%;\n    }\n    \n\n    .handssadmission {\n        margin-top: 20px;\n        position: relative;\n        background-color: #156614; \n        height: 300px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handpeertopeer {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 300px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .handsproreview {\n        margin-top: 70px;\n        position: relative; \n        background-color: #156614; \n        height: 270px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n    \n    .projectreeeview {\n        margin-top: 20px;\n        position: relative; \n        background-color: #156614; \n        height: 270px; \n        width: 100%; \n        margin-bottom: 15px;\n    }\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
